export let constants = {
  host: "https://lipayments.adityabirlacapital.com",
  uihost: "https://lipayments.adityabirlacapital.com"
};